import React, { Component } from 'react';
import MapaPDF from '../MapaPDF/MapaPDF.js';
import {
  Background,
  BlobWrapper,
  Checkbox,
  Content,
  Footer,
  InputWrapper,
  ModalContainer,
  NameInput,
  NameText,
  Title,
  DeleteInput,
  GenerarButton,
  ButtonsWrapper
} from './ModalPDFElement.js';
import { catalogObj as Data } from '../../../Catalog/Data';
import { getTranslatedKey } from '../../../Utils/TranslateUtils.js';
import { toast } from 'react-toastify';

export default class ModalPDF extends Component {
  constructor(props) {
    super(props);
    this.state = {
      docTitle: '', // Nombre del documento
      inputText: '', // Texto del input de nombre del mapa
      llegenda: true, // Incluir leyenda
      generar: false
    };
  }

  errorTrigger = () => {
    toast.error(getTranslatedKey('pdfError'));
    this.setState({ generar: false });
  };

  handleCheckbox = () => {
    this.setState({ llegenda: !this.state.llegenda });
  };

  clearInput = () => {
    this.setState({ inputText: '' });
  };

  generateDoc = () => {
    if(this.state.inputText !== ''){
    this.setState({ generar: true });
    setTimeout(() => {
      this.setState({ docTitle: this.state.inputText });
    }, 200);
  }else{
    toast.error(getTranslatedKey('errorNoName'))
  }
  };

  render() {
    return (
      <ModalContainer>
        <Background>
          <Title fontSizeEnabled={this.props.fontSizeEnabled} disabled={this.state.generar}>
            {getTranslatedKey('pdfTitle')}
          </Title>
          <Content>
            <InputWrapper>
              <NameText fontSizeEnabled={this.props.fontSizeEnabled} disabled={this.state.generar}>
                {getTranslatedKey('pdfMapTitle')}
              </NameText>
              <NameInput
                fontSizeEnabled={this.props.fontSizeEnabled}
                disabled={this.state.generar}
                placeholder={getTranslatedKey('mapNamePH')}
                value={this.state.inputText}
                maxLength="30"
                onChange={(e) => this.setState({ inputText: e.target.value })}
                onBlur={() => this.setState({ docTitle: this.state.inputText })}></NameInput>
              {this.state.inputText.length > 0 ? (
                <DeleteInput disabled={this.state.generar} onClick={() => this.clearInput()}>
                  <path
                    xmlns="http://www.w3.org/2000/svg"
                    d="M19,15.59L17.59,17L14,13.41L10.41,17L9,15.59L12.59,12L9,8.41L10.41,7L14,10.59L17.59,7L19,8.41L15.41,12L19,15.59M22,3A2,2 0 0,1 24,5V19A2,2 0 0,1 22,21H7C6.31,21 5.77,20.64 5.41,20.11L0,12L5.41,3.88C5.77,3.35 6.31,3 7,3H22M22,5H7L2.28,12L7,19H22V5Z"></path>
                </DeleteInput>
              ) : null}
            </InputWrapper>
            <Footer>
              <Checkbox
                disabled={this.state.generar}
                type="checkbox"
                img={Data.checkboxIcon}
                checked={this.state.llegenda}
                onChange={() => this.handleCheckbox()}></Checkbox>
              <NameText disabled={this.state.generar}>{getTranslatedKey('pdfLlegenda')}</NameText>
            </Footer>
            <ButtonsWrapper>
              {!this.state.generar ? (
                <GenerarButton fontSizeEnabled={this.props.fontSizeEnabled} disabled={this.state.generar} onClick={() => this.generateDoc()}>
                  {getTranslatedKey('pdfGenerar')}
                </GenerarButton>
              ) : (
                <BlobWrapper>
                  <MapaPDF
                    errorTrigger={this.errorTrigger}
                    docTitle={this.state.docTitle}
                    llegenda={this.state.llegenda}
                    scaleInt={this.props.scaleInt}
                    scale={this.props.scale}
                    arrayLayers={this.props.arrayLayers}
                    canvas={this.props.canvas}
                    img={this.props.img}
                  />
                </BlobWrapper>
              )}
            </ButtonsWrapper>
          </Content>
        </Background>
      </ModalContainer>
    );
  }
}
